
import React, { useState } from "react";
import { Drawer } from 'ui/Drawer';
import {Button} from "@material-ui/core";
import axios from "axios";
import { useSnackbar } from 'notistack';

export default function MassChangeDrawer({listContext, FormComponent}) {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const onSave = (formContext) => {
    setLoading(true);
    const item = formContext.item;
    let requests = [];
    listContext.getSelectedItems().forEach(selectedItem => {
      let updateFields = {};

      Object.keys(item).forEach(key => {
        if (item[key] !== null && item[key] !== undefined) {

          if (key === 'description') {
            const currentDescription = selectedItem.description || "";
            updateFields[key] = `${currentDescription}${currentDescription ? ' / ' : ''}${item[key]}`;
          } else {
            updateFields[key] = item[key];
          }

        }
      });

      requests.push(
        axios.patch(selectedItem.meta.url, updateFields, {
          item: selectedItem
        })
      );
    });
    axios.all(requests).then(results => {
      results.forEach(res => {
        enqueueSnackbar(`Перевозка #${res.config.item.id} обновлена`, {
          variant: 'success'
        });
      })
    }).catch(res => {
      if (res?.response?.data) {
        let snackbarMessage = `Ошибка при обновлении перевозки #${res.response.config.item.id}`;
        if (res.response.data.all_text_errors) {
          snackbarMessage += `\n${res.response.data.all_text_errors}`
        }
        enqueueSnackbar(snackbarMessage, {
          variant: 'error'
        });
      }
    }).finally(() => {
      setLoading(false);
      listContext.reload();
    })
  }

  return (
    <>
      <Button
        variant={'outlined'}
        onClick={() => setOpen(true)}
        disabled={listContext.getSelectedItems().length === 0}
      >
        Изменить выбранные
      </Button>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        width={'600px'}
        disableEscapeKeyDown={true}
      >
        <FormComponent listContext={listContext} loading={loading} onSave={onSave} />
      </Drawer>
    </>
  )
}